// ============================================================================
//  ballSpin — przyrostowy obrót piłki dla przemieszczenia prev→pos.
//  Czyste obliczenia (bez three) → łatwo testowalne. Pozycje jako [x,y,z],
//  wynik: { axis:[x,y,z], angle } do podania w mesh.rotateOnWorldAxis.
//
//  Dwa źródła obrotu:
//   • ruch poziomy → toczenie, oś = up × dir (up=(0,1,0));
//   • ruch czysto pionowy (kozioł, swish) → backspin wokół osi X, bo up × dir
//     wynosi 0 dla pionu i piłka inaczej zamarłaby (frozen ball, „dziwny" wygląd).
// ============================================================================

const BACKSPIN = 0.12  // udział prędkości pionowej w backspinie (spokojniejszy od toczenia)

// Maksymalna prędkość obrotu z ruchu (rad/s). Wzór toczenia (droga/promień)
// w locie dawał >25 rad/s — wizualna sieczka; prawdziwa piłka w grze obraca
// się znacznie wolniej. Konsument (shotCycle) clampuje kąt do MAX·dt.
export const MAX_SPIN_RATE = 3.0

const TUMBLE_RATE = 1.2  // rad/s — stała prędkość obrotu „myszkującego"
const PRECESS = 0.35     // rad/s — prędkość precesji osi tumblingu
const TILT = 0.8         // składowa pozioma osi (krąży wokół Y)
const LIFT = 0.6         // stała składowa pionowa osi

export function ballSpin(prev, pos, radius) {
  const dx = pos[0] - prev[0]
  const dy = pos[1] - prev[1]
  const dz = pos[2] - prev[2]

  const horiz = Math.hypot(dx, dz)
  if (horiz > 1e-4) {
    const ax = dz, az = -dx                 // up × dir, up=(0,1,0)
    const len = Math.hypot(ax, az) || 1
    return { axis: [ax / len, 0, az / len], angle: horiz / radius }
  }

  const vy = Math.abs(dy)
  if (vy > 1e-4) {
    // |vy| (nie dy) → stały kierunek backspinu niezależnie od wznoszenia/opadania.
    return { axis: [1, 0, 0], angle: (vy / radius) * BACKSPIN }
  }

  return { axis: [1, 0, 0], angle: 0 }
}

// Powolny, deterministyczny obrót „myszkujący": stała prędkość kątowa, oś
// precesuje w czasie → złożony z toczeniem daje obrót we wszystkich osiach
// (naprawia wirowanie „jak na rożnie" wokół samej osi X).
export function tumbleSpin(t, dt) {
  const ax = Math.sin(PRECESS * t) * TILT
  const ay = LIFT
  const az = Math.cos(PRECESS * t) * TILT
  const len = Math.hypot(ax, ay, az)
  return { axis: [ax / len, ay / len, az / len], angle: TUMBLE_RATE * dt }
}
